import CastForEducationOutlinedIcon from "@mui/icons-material/CastForEducationOutlined";
import FitnessCenterOutlinedIcon from "@mui/icons-material/FitnessCenterOutlined";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import MovieCreationOutlinedIcon from "@mui/icons-material/MovieCreationOutlined";
import SchoolOutlined from "@mui/icons-material/SchoolOutlined";
import React from "react";
import Widget from "./../widget/Widget";
import "./topwidgets.scss";
function TopWidgets({ data }) {
  return (
    <div className="widgets flex gap-2 flex-wrap justify-center">
      <Widget
        title="Schools"
        number={Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
        }).format(data.school_cnt)}
        link="View schools"
        diff={40}
        icon={
          <SchoolOutlined
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Smart Classes"
        number={Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
        }).format(data.center_cnt)}
        link="View centers"
        diff={20}
        icon={
          <CastForEducationOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />

      <Widget
        title="Video Usage ( In Minutes )"
        number={Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
        }).format(data.video_usage_cnt)}
        diff={-10}
        icon={
          <MovieCreationOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
      <Widget
        title="Exercise Usage ( In Minutes )"
        number={Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
        }).format(data.excs_usage_cnt)}
        diff={30}
        icon={
          <FitnessCenterOutlinedIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />

      <Widget
        title="Teacher Trained"
        number={Intl.NumberFormat("en-US", {
          notation: "compact",
          compactDisplay: "short",
        }).format(data.teacher_cnt)}
        diff={30}
        icon={
          <HistoryEduIcon
            className="icon"
            style={{
              backgroundColor: "rgba(0, 128, 0, 0.2)",
              color: "green",
              fontSize: "2.5rem",
            }}
          />
        }
      />
    </div>
  );
}

export default TopWidgets;
